<template>
  <!-- 旧旧版踏襲 (RenderQuestionnaire.vue:103-106): separator は薄い横線 1 本
       縦 gap は親 QuestionnaireForm の space-y-6 で支配するため my-* は付けない。 -->
  <hr v-if="field.type === 'separator'" class="border-0 border-b-2 border-q4cl-border" aria-hidden="true" />
  <div v-else :id="field.name" :style="field.style || undefined">
    <h2 v-if="field.type === 'section'" class="section-heading" v-html="markdownTitle"></h2>
    <h3 v-else-if="field.type === 'subsection'" class="subsection-heading" v-html="markdownTitle"></h3>
    <div v-if="field.type === 'note'" class="note-block" v-html="markdownBody"></div>
    <!-- 旧旧版踏襲: clipart の img にも field.style を当てる (サイズ調整等の inline 指定) -->
    <img v-else-if="field.type === 'clipart' && field.src" :src="field.src" :alt="field.alt || ''" :style="field.style || undefined" class="max-w-full h-auto rounded-q4cl border border-q4cl-border my-2" />
    <div v-if="field.description && field.type !== 'note'" class="text-xs text-q4cl-muted mt-1 whitespace-pre-line" v-html="markdownDescription"></div>
  </div>
</template>

<script>
export default {
  name: 'SectionField',
  props: { field: { type: Object, required: true } },
  setup(props) {
    const i18n = window.i18nStore;
    function md(text) {
      if (!text) return '';
      try { return DOMPurify.sanitize(marked.parseInline(text)); } catch (e) { return text; }
    }
    // 配列なら \n で join (旧旧版 getJoined 踏襲)
    function joinIfArr(v) {
      if (v == null) return '';
      return Array.isArray(v) ? v.join('\n') : v;
    }
    const markdownTitle = Vue.computed(() => md(i18n ? i18n.i18n(props.field.dispname) : props.field.dispname));
    const markdownBody = Vue.computed(() => {
      const raw = joinIfArr(props.field.description);
      const t = i18n ? i18n.i18n(raw) : raw;
      try { return DOMPurify.sanitize(marked.parse(t)); } catch (e) { return t; }
    });
    // description は block-level Markdown もサポート (リスト・段落・コードブロック等)
    const markdownDescription = Vue.computed(() => {
      const raw = joinIfArr(props.field.description);
      const t = i18n ? i18n.i18n(raw) : raw;
      try { return DOMPurify.sanitize(marked.parse(t)); } catch (e) { return t; }
    });
    return { markdownTitle, markdownBody, markdownDescription };
  }
};
</script>
